export function isTempLibertyEmail(email) {
  if (!email || typeof email !== 'string') return false;
  const normalized = email.trim().toLowerCase();
  return normalized.endsWith('@temp.liberty') && normalized.startsWith('phone_');
}

export function publicEmail(email) {
  if (!email || isTempLibertyEmail(email)) return null;
  return email;
}
